import { render, staticRenderFns } from "./InterviewForm.vue?vue&type=template&id=65de796b&"
import script from "./InterviewForm.vue?vue&type=script&lang=js&"
export * from "./InterviewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports